// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__Rso3D","header":"PatientQuestionnaire_header__1woi6","info":"PatientQuestionnaire_info__1ZknF"};